import React, { Component } from "react";
import logo from "./../../assets/ic_logo_new.svg";
import menu from "./../../assets/ic_menu.svg";
import { SELECTED_SIDE_BAR_ITEM_KEY } from "../../common/SidebarContent/SidebarContent";
import { AlignRight } from "react-feather";

class ESPNavbar extends Component 
{
  constructor(props) 
  {
    super(props);
    this.state = { selectedItemPath: null };
  }

  handleItemClick = item => {
    this.setState({ selectedItemPath: item.path });
    localStorage.setItem("SELECTED_SIDE_BAR_ITEM", item.path);
    if (item.id === "logout") {
      localStorage.clear();
    }
    this.props.history.push(`${item.path}`);
  };


  render() {
    return (
      <div className="navbar fixed-top flex-md-nowrap" style={{textAlign:"center",backgroundColor:"#F2F2F2"}}>
        <div style={{float:"left",width:"135px"}}>
          <img
            alt="deasra-icon"
            src={logo}
            className="h30 cursor-pointer" 
            onClick={() => {
              localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, "/service_partner/dashboard");

              /**
               * function to move between routes.
               */
              this.props.history.push("/service_partner/dashboard");
            }}           
          />

          {/* <NavMenu
          onItemClick={route => this.handleItemClick(route)}
          {...this.props}
        /> */}
        </div>        
        
        <div style={{float:"left",textAlign:"center",marginLeft:"-100px"}}>
          <span className="page-title">{this.props.Pagetitle}</span>
        </div>
        <div style={{float:"left",width:"25px",marginRight:"20px"}}>
          <div className="cursor-pointer" onClick={this.props.toggleSidebar}>
            <img
              alt="menu"
              src={menu}
              className="menu-logo"         
            />
          </div>
        </div >
      </div>
    );
  }
}

export default ESPNavbar;
